import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const PermitScheme = () => {
  return (
    <div className="about-us">

      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Permit Scheme</h1>
          <p className="subtitle">
            This scheme certifies products that comply with Malawi Standards and allows the use of the MBS Quality Mark.
          </p>
        </div>
      </section>

      {/* === Overview Section === */}
      <section className="what-section">
        <h2 className="section-title">Overview</h2>

        <p className="paragraph">
          Under the Permit Scheme, units manufacturing products covered by specific Malawi Standards are inspected periodically.
          When the products consistently comply with the relevant standards, they are certified, and Permit Certificates are issued
          to allow the use of the MBS Quality Mark.
        </p>

        <p className="paragraph" style={{ fontWeight: 'bold' }}>
          NOTE: It is a criminal offence under the Malawi Bureau of Standards Act (Cap. 51.02) of the Laws of Malawi to display 
          the MBS Quality Mark without a current and valid permit issued by the MBS.
        </p>

        <h3 className="section-title centered-text">Contact Information</h3>
        <p className="paragraph centered-text">
          For details on how to qualify for the use of the MBS Quality Mark, please contact:
        </p>

        <p className="paragraph centered-text">
          Director General<br />
          Malawi Bureau of Standards<br />
          P.O. Box 946, Blantyre<br />
          E-mail: <a href="mailto:mbs@mbsmw.org">mbs@mbsmw.org</a>
        </p>
      </section>

      <br /><br />

      {/* === Inline Styles === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
        }

        .page-title { font-size: 2.5rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }

        .what-section { padding: 50px 80px; }
        .section-title {
          font-size: 1.8rem;
          font-weight: bold;
          margin-bottom: 20px;
          text-align: center;
        }

        .paragraph {
          font-size: 1rem;
          line-height: 1.7;
          margin: 15px 0;
          text-align: left;
        }

        .centered-text { text-align: center; }

        a {
          color: #ff6600;
          font-weight: bold;
          text-decoration: none;
        }

        a:hover { text-decoration: underline; }

        @media screen and (max-width: 768px) {
          .what-section { padding: 25px 20px; }
          .page-title { font-size: 2rem; }
          .overlay { width: 95%; padding: 25px; }
        }
      `}</style>

    </div>
  );
};

export default PermitScheme;
